// extracted by mini-css-extract-plugin
export default {"custom-content":"confluence-style_custom-content__sjxX2","confluence-information-macro-body":"confluence-style_confluence-information-macro-body__w+qUx"};